export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    CLEAR(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.clear()
    }
  },
  actions: {
    login({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_TOKEN', 'demo-token-123456')
        commit('SET_USER_INFO', { name: '管理员', id: 1 })
        resolve()
      })
    },
    logout({ commit }) {
      commit('CLEAR')
    }
  }
}